module.exports = __webpack_public_path__ + "static/img/page1.c5f8bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/doudouImg/page1.png
// module id = x2mU
// module chunks = 1